import type { Dict } from "../lib/i18n";

// Keys are prefixed "shopping." — keep zh / en / nl in step.
export default {
  zh: {
    "shopping.share.needsPlus": "家庭共享是 Plus 会员功能。家里有一个人订阅 Plus（免费试用期内也可以），全家就能共用清单、账本、食材库、物品库和这个 Plus。",
    "shopping.share.paused": "这个家庭的共享暂停了：需要家里有人订阅 NutriCart Plus 才能继续共享。",
    "shopping.share.title": "我的家庭",
    "shopping.share.stripOff": "和家人共享",
    "shopping.share.short": "共享",
    "shopping.share.stripOffSub": "购物清单、账本、食材库、物品库，全家一起用",
    "shopping.share.intro": "全家用同一个购物清单、家庭账本、智能食材库和物品库：谁拍的小票、谁买的菜、谁勾掉的东西，全家马上都能看到。一个 Plus 全家一起用。每个人的饮食记录、体重和会员卡仍然各自保密。",
    "shopping.share.step3": "家人有 NutriCart 账号的话，点“申请加入家庭”；你在这里点“同意”后，他就和全家共用账本、食材库和 Plus。",
    "shopping.share.safety": "拿到链接、没有账号的人只能看到和修改购物清单；要加入家庭（看到账本等），必须经过你同意。",
    "shopping.share.joinTitle": "加入这个家庭",
    "shopping.share.joinHint": "加入后，全家共用购物清单、家庭账本、食材库、物品库和 Plus；你原来的这些记录会合并进家庭。你的饮食记录、体重和会员卡仍然只有你自己能看到。需要家里人同意。",
    "shopping.share.join": "申请加入家庭",
    "shopping.share.signUpHint": "注册 NutriCart（购物清单永久免费），然后申请加入家庭，全家共用一个 Plus。",
    "shopping.share.signUp": "免费注册并申请加入",
    "shopping.share.signIn": "我有账号，登录并申请加入",
    "shopping.share.stopBody": "链接失效，家人回到各自的账号（空的）。家里共用的账本、食材库和清单都留在你这里。",
    "shopping.share.leaveBody": "你会回到自己的账号，清单、账本和食材库从空的开始；家里的记录留在家庭里。以后可以再申请加入。",
    "shopping.share.leave": "退出这个家庭",
    "shopping.share.leaveTitle": "退出家庭？",
    "shopping.share.youJoined": "你在 {name} 的家庭里：清单、账本、食材库、物品库和 Plus 全家共用。",
    "shopping.share.stripOn": "{name} 的家庭 · {n} 人",
    "shopping.share.stripOnSub": "清单、账本、食材库全家一起用，谁改了大家马上看到",
    "shopping.share.stripAsks": "有 {n} 人申请加入你的家庭，点开看看",
    "shopping.share.asks": "{name} 申请加入家庭",
    "shopping.share.asksHint": "同意后，对方能看到家庭账本、食材库和物品库。确认是家里人再同意。",
    "shopping.share.accept": "同意",
    "shopping.share.decline": "不同意",
    "shopping.share.waiting": "已经申请加入 {name} 的家庭，等家里人同意。",
    "shopping.share.asked": "已发送申请，等 {name} 家里的人同意后，清单、账本和食材库就会出现在你的 App 里。",
    "shopping.share.step1": "点“发给家人”，用微信、WhatsApp 或短信把链接发出去。",
    "shopping.share.step2": "家人点开链接就能看到清单，不用注册也能加东西、打勾。",
    "shopping.share.make": "生成家庭共享链接",
    "shopping.share.send": "发给家人",
    "shopping.share.copy": "复制链接",
    "shopping.share.copied": "链接已复制，可以粘贴到微信或 WhatsApp 里发给家人。",
    "shopping.share.message": "我们家的购物清单，点开就能看、能加、能打勾：",
    "shopping.share.who": "家里的人（{n}）",
    "shopping.share.me": "我",
    "shopping.share.renew": "换一个新链接",
    "shopping.share.renewTitle": "换一个新链接？",
    "shopping.share.renewBody": "旧链接马上失效（比如发错了人）。已经加入的家人不受影响。",
    "shopping.share.stop": "停止共享",
    "shopping.share.stopTitle": "停止共享？",
    "shopping.share.gone": "这个链接已经失效了。请向家人要一个新的链接。",
    "shopping.share.family": "家庭购物清单",
    "shopping.share.listOf": "{name} 的家庭清单",
    "shopping.share.guestIntro": "想到要买什么就加上，买到了就点圆圈打勾。家人那边马上能看到。",
    "shopping.share.addPh": "例如：牛奶两瓶, 面包",
    "shopping.share.add": "加上",
    "shopping.share.toBuy": "要买的 · {n}",
    "shopping.share.allDone": "都买好了 👍",
    "shopping.share.bought": "已经买了 · {n}",
    "shopping.share.openMine": "打开我的购物清单",
    "shopping.cheer.say": "太好了！",
    "shopping.cheer.advice": "按计划买、又碰上打折，省下的钱会记进账本的“促销”里。",
    "shopping.cheer.line": "太好了！买到优惠啦，真会过日子！",
    "shopping.offer.open": "拍打折牌，分享给大家",
    "shopping.offer.title": "分享店里的打折",
    "shopping.offer.intro": "在超市看到打折牌、货架价签或宣传单？拍一张，AI 读出商品和价格，你确认后分享给所有 NutriCart 用户。大家的购物清单上，同样的东西旁边就会显示这个打折。分享是匿名的，别人看不到是谁拍的。",
    "shopping.offer.needsPlus": "拍照分享打折是 Plus 功能；看别人分享的打折永久免费",
    "shopping.offer.photo": "打折牌或宣传单",
    "shopping.offer.reading": "正在读打折信息…",
    "shopping.offer.store": "哪家超市",
    "shopping.offer.until": "到{date}",
    "shopping.offer.was": "原价 {amount}",
    "shopping.offer.check": "请核对一下：只勾选读对了的。没印结束日期的，按荷兰超市习惯算到本周日。",
    "shopping.offer.share": "分享 {n} 个打折",
    "shopping.offer.shared": "已分享 {n} 个打折，谢谢你！",
    "shopping.offer.noneRead": "这张照片里没读到打折。请拍清楚一点，让价格和商品名都在画面里。",
    "shopping.offer.needStore": "请填上是哪家超市。",
    "shopping.offer.needOne": "请至少勾选一个打折。",
    "shopping.offer.dailyLimit": "今天分享的打折已经到 {limit} 个上限了，明天再继续吧。",
    "shopping.offer.mine": "我分享的、还在进行的打折（{n}）",
    "shopping.offer.remove": "撤回“{name}”",
    "shopping.offer.lastDeal": "上次 {date} 在 {store} 打折买的，省了 {amount}",
    "shopping.autoExtra": "你正在店里购物，临时加的东西已标为“计划外”。点商品右边的笔可以改。",
    "shopping.willAdd": "将加入：{list}",
    "shopping.addHint": "可以一次写好几样，用逗号分开，比如“牛奶两瓶，面包，鸡蛋6个”。点麦克风可以直接说。",
    "shopping.addHintShop": "你正在店里：现在加的东西会算作“计划外”。",
    "shopping.tapToTick": "点商品就能打勾；点右边的笔可以改数量、单位或类型。",
    "shopping.recordReceiptPlus": "拍下小票，已买的东西会和小票一一对应，退瓶退款也不会忘。这是 Plus 功能。",
    "shopping.clearBodyUnlinked": "从清单中拿掉 {n} 项已买到的商品（仍在“购物历史”里保留一周）。其中 {m} 项还没有对上小票，清除后就不能再对应了。",
    "shopping.onReceipt": "已对上一张小票，点开查看",
    "shopping.onReceiptShort": "已对上小票",
    "shopping.recordAmount": "没有小票？直接记金额",
    "shopping.recordReceiptHint": "有小票就用首页或账本里的“拍小票”：保存时会自动勾上这里买到的东西、记进账本、食品放进食材库。",
    "shopping.atHome": "食材库里还有 {qty}",
    "shopping.atHomeDays": "食材库里还有 {qty}，还能放 {n} 天",
    "shopping.atHomeExpired": "食材库里还有 {qty}，但已过期",
    "shopping.atHomeToast": "温馨提示：你的“{home}”{more}。确定还要买“{name}”吗？",
    "shopping.atHomeSkip": "不买了",
    "shopping.estimate": "预计这次大约 {amount}（{total} 样里 {n} 样知道价格）",
    "shopping.budgetLeft": "本月预算还剩 {amount}",
    "shopping.budgetOver": "本月已超出预算 {amount}",
    "shopping.estimateOver": "可能超出预算",
    "shopping.soon.title": "快用完了吗？按你平时的购买习惯",
    "shopping.soon.line": "约每 {every} 天买一次，上次 {date}",
    "shopping.soon.add": "加入",
    "shopping.soon.addAll": "全部加入",
    "shopping.soon.addOne": "把“{name}”加进清单",
    "shopping.soon.hint": "根据你的小票推算：买过 3 次以上的东西才会提醒；清单上已有的、食材库里还够的不提醒。",
    "shopping.boughtBefore": "{date} 买过（半年内 {n} 次）",
    "shopping.boughtBeforeToast": "温馨提示：物品库里有“{home}”，{date} 买的（半年内 {n} 次）。还需要再买“{name}”吗？是否必要？",
    "shopping.batch.kindHint": "句子里说了“促销”“打折”“计划外”“顺便”的会自动标好；点每样后面的标签可以改。",
    "shopping.batch.changeKind": "切换“{name}”的类型",
    "shopping.nudge.1.say": "哎呀～这个不在清单上哦，真的需要吗？",
    "shopping.nudge.2.say": "嘻嘻，赚钱不容易呀，我们省一点点好不好？",
    "shopping.nudge.3.say": "能省一点是一点哦～你最棒啦！",
    "shopping.nudge.4.say": "等一下下～家里是不是还有呀？",
    "shopping.title": "购物清单",
    "shopping.hero": "先计划，再购物",
    "shopping.heroSub": "把要买的写下来，在店里逐项打勾，少买计划外的东西。",
    "shopping.add": "加入清单",
    "shopping.added": "已加入：{name}",
    "shopping.alreadyListed": "清单里已经有这一项了。",
    "shopping.removed": "已删除：{name}",
    "shopping.open": "要买的 · {n}",
    "shopping.completed": "已买到 · {n}",
    "shopping.allDone": "全部买齐了！",
    "shopping.markBought": "{name}：标记为已买",
    "shopping.markOpen": "{name}：改回未买",
    "shopping.editItem": "编辑 {name}",
    "shopping.stillNeed": "还差 {qty}",
    "shopping.overPlan": "比计划多买 {qty}",
    "shopping.clearCompleted": "清除已买",
    "shopping.clearBody": "从清单中拿掉 {n} 项已买到的商品。它们仍会在“购物历史”里保留一周。",
    "shopping.clearConfirm": "清除",
    "shopping.cleared": "已清除已买的商品",
    "shopping.retention": "已买到的商品 {n} 天后从清单上消失，在“购物历史”里保留 {h} 天；还没买的会一直保留。",
    "shopping.history.open": "购物历史（最近 {n} 天）",
    "shopping.history.title": "购物历史",
    "shopping.history.intro": "最近 {n} 天买到的东西，按天排列。超过 {n} 天的会自动删除。",
    "shopping.history.empty": "最近 {n} 天还没有买到的东西。",
    "shopping.history.booked": "已记账：{store} {amount}",
    "shopping.history.notBooked": "还没记账",
    "shopping.history.count": "{n} 样",
    "shopping.empty.title": "清单还是空的",
    "shopping.empty.body": "在上面输入要买的东西，或点下面最近买过、常用商品里的名字，一点就加进清单。",

    "shopping.field.name": "商品",
    "shopping.field.namePlaceholder": "例如：牛奶",
    "shopping.field.needed": "数量",
    "shopping.field.bought": "已买",
    "shopping.field.unit": "单位",
    "shopping.field.unitPlaceholder": "瓶、包、公斤…",
    "shopping.field.category": "分类",
    "shopping.field.kind": "计划内还是计划外",
    "shopping.kind.planned": "计划内",
    "shopping.kind.extra": "计划外",
    "shopping.kind.discount": "促销",
    "shopping.error.check": "请检查商品名称和数量。",
    "shopping.error.qty": "请输入 0.01 到 10000 之间的数字",

    "shopping.cat.other": "其他",
    "shopping.cat.produce": "蔬菜水果",
    "shopping.cat.protein": "肉蛋奶",
    "shopping.cat.staples": "主食调料",
    "shopping.cat.snacks": "零食饮料",
    "shopping.cat.household": "日用品",

    "shopping.edit.title": "编辑商品",
    "shopping.edit.remove": "删除",

    "shopping.picker.title": "从常用商品中选择",
    "shopping.picker.recent": "最近买过",
    "shopping.picker.listed": "已在清单中",
    "shopping.picker.addOne": "把 {name} 加入清单",

    "shopping.nudge.1": "这个真的需要吗？",
    "shopping.nudge.2": "赚钱不容易呀！",
    "shopping.nudge.3": "能省一点是一点！",
    "shopping.nudge.4": "先想一想，家里是不是还有？",
    "shopping.nudge.advice": "停一下，看看家里已有的东西和这个月的预算。",

    "shopping.batch.open": "说出来添加",
    "shopping.batch.title": "一次添加多样",
    "shopping.batch.intro": "把要买的东西一次写下来，用逗号或换行分开。",
    "shopping.batch.introVoice": "把要买的东西一次写下来或说出来，用逗号或换行分开。语音识别由浏览器提供，免费，不消耗 AI 次数。",
    "shopping.batch.label": "要买的东西",
    "shopping.batch.placeholder": "牛奶两瓶，面包，鸡蛋6个",
    "shopping.batch.example": "可以写数量和单位，比如“两瓶牛奶”或“鸡蛋6个”。",
    "shopping.batch.speak": "开始说话",
    "shopping.batch.stop": "停止",
    "shopping.batch.listening": "正在听…",
    "shopping.batch.micNote": "点“开始说话”，说完会自动停止。浏览器可能会请求使用麦克风。",
    "shopping.batch.micBlocked": "麦克风权限被拒绝了。可以在浏览器设置中允许，或者直接输入。",
    "shopping.batch.noSpeech": "没有听到声音，请再试一次。",
    "shopping.batch.noMic": "找不到麦克风。可以直接输入。",
    "shopping.batch.micNetwork": "语音识别需要网络连接，请稍后再试或直接输入。",
    "shopping.batch.micFailed": "语音识别没能启动，请直接输入。",
    "shopping.batch.preview": "识别到 {n} 项",
    "shopping.batch.untick": "取消勾选不想添加的项目。添加后可以点任意一项修改。",
    "shopping.batch.nothing": "还没识别出商品。用逗号把每一样分开试试。",
    "shopping.batch.add": "添加 {n} 项",
    "shopping.batch.addNone": "添加",
    "shopping.batch.added": "已添加 {n} 项",
  },
  en: {
    "shopping.share.needsPlus": "Family sharing is part of Plus. When one person in the family subscribes (the free trial counts too), the whole family shares the list, budget, pantry, things at home and that Plus.",
    "shopping.share.paused": "Sharing for this family is paused: someone in the family needs NutriCart Plus to share again.",
    "shopping.share.title": "My family",
    "shopping.share.stripOff": "Share with your family",
    "shopping.share.short": "Share",
    "shopping.share.stripOffSub": "Shopping list, budget, pantry and things at home, together",
    "shopping.share.intro": "One shopping list, budget, pantry and list of things at home for the whole family: whoever scans a receipt, buys food or ticks something off, everyone sees it right away. One Plus for the whole family. Each person's meals, weight and loyalty cards stay their own.",
    "shopping.share.step3": "Family with a NutriCart account tap “Ask to join the family”; once you tap “Accept” here, they share the budget, pantry and Plus.",
    "shopping.share.safety": "With just the link (no account), people can only see and change the shopping list; joining the family (budget and so on) always needs your OK.",
    "shopping.share.joinTitle": "Join this family",
    "shopping.share.joinHint": "Once in, the family shares the shopping list, budget, pantry, things at home and Plus; what you kept on your own is merged into the family's. Your meals, weight and loyalty cards stay yours. Someone in the family has to accept you.",
    "shopping.share.join": "Ask to join the family",
    "shopping.share.signUpHint": "Sign up for NutriCart (the shopping list is free forever), then ask to join the family and share one Plus.",
    "shopping.share.signUp": "Sign up free and ask to join",
    "shopping.share.signIn": "I have an account: sign in and ask",
    "shopping.share.stopBody": "The link stops working and family members go back to their own (empty) accounts. The shared budget, pantry and list stay with you.",
    "shopping.share.leaveBody": "You go back to your own account, starting with an empty list, budget and pantry; the family's records stay with the family. You can ask to join again later.",
    "shopping.share.leave": "Leave this family",
    "shopping.share.leaveTitle": "Leave the family?",
    "shopping.share.youJoined": "You're in {name}'s family: list, budget, pantry, things at home and Plus are shared.",
    "shopping.share.stripOn": "{name}'s family · {n} people",
    "shopping.share.stripOnSub": "List, budget and pantry shared: changes show for everyone right away",
    "shopping.share.stripAsks": "{n} asking to join your family — tap to see",
    "shopping.share.asks": "{name} asks to join the family",
    "shopping.share.asksHint": "Once accepted, they see the family budget, pantry and things at home. Accept only family.",
    "shopping.share.accept": "Accept",
    "shopping.share.decline": "Decline",
    "shopping.share.waiting": "You asked to join {name}'s family; waiting for them to accept.",
    "shopping.share.asked": "Request sent. Once someone in {name}'s family accepts, the list, budget and pantry appear in your app.",
    "shopping.share.step1": "Tap “Send to family” and send the link by WhatsApp, WeChat or text message.",
    "shopping.share.step2": "Your family opens the link and sees the list; they can add and tick off without an account.",
    "shopping.share.make": "Create the family link",
    "shopping.share.send": "Send to family",
    "shopping.share.copy": "Copy link",
    "shopping.share.copied": "Link copied: paste it into WhatsApp or WeChat for your family.",
    "shopping.share.message": "Our family shopping list — open it to see, add and tick off:",
    "shopping.share.who": "In the family ({n})",
    "shopping.share.me": "me",
    "shopping.share.renew": "New link",
    "shopping.share.renewTitle": "Make a new link?",
    "shopping.share.renewBody": "The old link stops working right away (for example if it went to the wrong person). Family who joined stay on the list.",
    "shopping.share.stop": "Stop sharing",
    "shopping.share.stopTitle": "Stop sharing?",
    "shopping.share.gone": "This link no longer works. Ask your family for a new one.",
    "shopping.share.family": "Family shopping list",
    "shopping.share.listOf": "{name}'s family list",
    "shopping.share.guestIntro": "Add what you think of; tap the circle when you've bought it. Your family sees it right away.",
    "shopping.share.addPh": "e.g. 2 milk, bread",
    "shopping.share.add": "Add",
    "shopping.share.toBuy": "To buy · {n}",
    "shopping.share.allDone": "All bought 👍",
    "shopping.share.bought": "Bought · {n}",
    "shopping.share.openMine": "Open my shopping list",
    "shopping.cheer.say": "Yay, well done!",
    "shopping.cheer.advice": "Planned and on offer: the savings show up under “offers” in your budget.",
    "shopping.cheer.line": "Yay! Got it on offer, nicely done!",
    "shopping.offer.open": "Snap an offer, share it with everyone",
    "shopping.offer.title": "Share an offer from the shop",
    "shopping.offer.intro": "Seen an offer sign, shelf label or folder in the shop? Take a photo, the AI reads the products and prices, and once you've checked them they're shared with everyone on NutriCart. Everyone's shopping list then shows the offer next to the same thing. Sharing is anonymous: nobody sees who took the photo.",
    "shopping.offer.needsPlus": "Sharing offers by photo is part of Plus; seeing others' offers is free forever",
    "shopping.offer.photo": "Offer sign or folder",
    "shopping.offer.reading": "Reading the offers…",
    "shopping.offer.store": "Which shop",
    "shopping.offer.until": "until {date}",
    "shopping.offer.was": "was {amount}",
    "shopping.offer.check": "Please check: tick only what was read correctly. Without a printed end date, an offer runs until Sunday, as in Dutch shops.",
    "shopping.offer.share": "Share {n} offers",
    "shopping.offer.shared": "{n} offers shared, thank you!",
    "shopping.offer.noneRead": "No offers found on this photo. Try a sharper photo with the price and product name in view.",
    "shopping.offer.needStore": "Please fill in which shop.",
    "shopping.offer.needOne": "Please tick at least one offer.",
    "shopping.offer.dailyLimit": "You've shared {limit} offers today, the daily maximum. Carry on tomorrow.",
    "shopping.offer.mine": "Offers I shared that are still running ({n})",
    "shopping.offer.remove": "Take back “{name}”",
    "shopping.offer.lastDeal": "Last bought on offer at {store} on {date}, saved {amount}",
    "shopping.autoExtra": "You're in the shop, so what you add now is marked \"unplanned\". Tap the pencil to change it.",
    "shopping.willAdd": "Will add: {list}",
    "shopping.addHint": "Add several at once, separated by commas, e.g. \"2 bottles of milk, bread, 6 eggs\". Tap the microphone to say it.",
    "shopping.addHintShop": "You're in the shop: what you add now counts as unplanned.",
    "shopping.tapToTick": "Tap an item to tick it off; tap the pencil to change quantity, unit or type.",
    "shopping.recordReceiptPlus": "Photograph the receipt and your list is matched to it line by line, bottle deposits included. This is a Plus feature.",
    "shopping.clearBodyUnlinked": "Take {n} bought items off the list (they stay in your shopping history for a week). {m} of them aren't matched to a receipt yet and can't be matched after clearing.",
    "shopping.onReceipt": "On a receipt, tap to open it",
    "shopping.onReceiptShort": "On receipt",
    "shopping.recordAmount": "No receipt? Note the amount",
    "shopping.recordReceiptHint": "Got a receipt? Use “Scan receipt” on the home screen or in the budget: saving it ticks these off, books the spending and puts the food in the pantry.",
    "shopping.atHome": "the pantry still has {qty}",
    "shopping.atHomeDays": "the pantry still has {qty}, good for {n} more days",
    "shopping.atHomeExpired": "the pantry still has {qty}, but it has expired",
    "shopping.atHomeToast": "Just so you know: “{home}” — {more}. Still buy “{name}”?",
    "shopping.atHomeSkip": "Don't buy",
    "shopping.estimate": "About {amount} this time ({n} of {total} with a known price)",
    "shopping.budgetLeft": "{amount} left in this month's budget",
    "shopping.budgetOver": "{amount} over this month's budget",
    "shopping.estimateOver": "may go over the budget",
    "shopping.soon.title": "Running out soon? From how often you buy it",
    "shopping.soon.line": "Usually every {every} days, last on {date}",
    "shopping.soon.add": "Add",
    "shopping.soon.addAll": "Add all",
    "shopping.soon.addOne": "Add “{name}” to the list",
    "shopping.soon.hint": "Worked out from your receipts: only for things bought 3 times or more, and not when it's on the list or the pantry still has enough.",
    "shopping.boughtBefore": "bought {date} ({n}× in half a year)",
    "shopping.boughtBeforeToast": "Just so you know: your home goods have “{home}”, bought {date} ({n}× in half a year). Do you need “{name}” again?",
    "shopping.batch.kindHint": "Words like \"on offer\" or \"extra\" set the type automatically; tap the label after each item to change it.",
    "shopping.batch.changeKind": "Change the type of “{name}”",
    "shopping.nudge.1.say": "Oopsie! That one wasn't on the list. Do you really need it?",
    "shopping.nudge.2.say": "Hee hee, money doesn't grow on trees! Shall we save a little?",
    "shopping.nudge.3.say": "Every little bit you save counts. You're doing great!",
    "shopping.nudge.4.say": "Wait a sec! Is there still some at home?",
    "shopping.title": "Shopping list",
    "shopping.hero": "Plan before you shop",
    "shopping.heroSub": "Write down what you need, tick it off in the shop and skip the extras.",
    "shopping.add": "Add to list",
    "shopping.added": "Added {name}",
    "shopping.alreadyListed": "This is already on your list.",
    "shopping.removed": "Removed {name}",
    "shopping.open": "To buy · {n}",
    "shopping.completed": "Got it · {n}",
    "shopping.allDone": "You've got everything!",
    "shopping.markBought": "Mark {name} as bought",
    "shopping.markOpen": "Mark {name} as not bought",
    "shopping.editItem": "Edit {name}",
    "shopping.stillNeed": "still need {qty}",
    "shopping.overPlan": "{qty} over plan",
    "shopping.clearCompleted": "Clear completed",
    "shopping.clearBody": "Take everything you've already bought ({n}) off the list. It stays in your shopping history for a week.",
    "shopping.clearConfirm": "Clear",
    "shopping.cleared": "Completed items cleared",
    "shopping.retention": "Items you've bought leave the list after {n} days and stay {h} days in your shopping history. Items still to buy stay until you remove them.",
    "shopping.history.open": "Shopping history (last {n} days)",
    "shopping.history.title": "Shopping history",
    "shopping.history.intro": "What you bought in the last {n} days, by day. Anything older is deleted automatically.",
    "shopping.history.empty": "Nothing bought in the last {n} days.",
    "shopping.history.booked": "In the budget: {store} {amount}",
    "shopping.history.notBooked": "Not in the budget yet",
    "shopping.history.count": "{n} items",
    "shopping.empty.title": "Your list is empty",
    "shopping.empty.body": "Type a product above and tap “Add to list”, pick from common products, or use “Type or say several” to add a few at once.",

    "shopping.field.name": "Product",
    "shopping.field.namePlaceholder": "e.g. Milk",
    "shopping.field.needed": "Quantity",
    "shopping.field.bought": "Bought",
    "shopping.field.unit": "Unit",
    "shopping.field.unitPlaceholder": "bottles, packs, kg…",
    "shopping.field.category": "Category",
    "shopping.field.kind": "Planned or not",
    "shopping.kind.planned": "Planned",
    "shopping.kind.extra": "Unplanned",
    "shopping.kind.discount": "On offer",
    "shopping.error.check": "Please check the product name and quantity.",
    "shopping.error.qty": "Enter a number from 0.01 to 10000",

    "shopping.cat.other": "Other",
    "shopping.cat.produce": "Fruit & veg",
    "shopping.cat.protein": "Meat, eggs & dairy",
    "shopping.cat.staples": "Pantry",
    "shopping.cat.snacks": "Snacks & drinks",
    "shopping.cat.household": "Household",

    "shopping.edit.title": "Edit item",
    "shopping.edit.remove": "Remove",

    "shopping.picker.title": "Choose from common products",
    "shopping.picker.recent": "Recent",
    "shopping.picker.listed": "Already on the list",
    "shopping.picker.addOne": "Add {name} to the list",

    "shopping.nudge.1": "Do you really need it?",
    "shopping.nudge.2": "Money doesn't grow on trees!",
    "shopping.nudge.3": "Let's save where we can!",
    "shopping.nudge.4": "Maybe there's still some at home?",
    "shopping.nudge.advice": "Take a moment to think about what you already have and your budget.",

    "shopping.batch.open": "Say it",
    "shopping.batch.title": "Add several items",
    "shopping.batch.intro": "Write everything you need in one go, separated by commas or new lines.",
    "shopping.batch.introVoice": "Write or say everything you need in one go, separated by commas or new lines. Speech recognition comes from your browser: free, no AI reads used.",
    "shopping.batch.label": "What do you need?",
    "shopping.batch.placeholder": "2 bottles of milk, bread and 6 eggs",
    "shopping.batch.example": "Add amounts and units if you like, e.g. “2 bottles of milk” or “eggs x6”.",
    "shopping.batch.speak": "Start speaking",
    "shopping.batch.stop": "Stop",
    "shopping.batch.listening": "Listening…",
    "shopping.batch.micNote": "Tap “Start speaking”; it stops by itself when you pause. Your browser may ask to use the microphone.",
    "shopping.batch.micBlocked": "Microphone access was blocked. You can allow it in your browser settings, or just type.",
    "shopping.batch.noSpeech": "We didn't hear anything. Please try again.",
    "shopping.batch.noMic": "No microphone found. You can type instead.",
    "shopping.batch.micNetwork": "Speech recognition needs a connection. Try again later or type instead.",
    "shopping.batch.micFailed": "Speech recognition couldn't start. Please type instead.",
    "shopping.batch.preview": "Found · {n}",
    "shopping.batch.untick": "Untick anything you don't want. You can tap any item later to change it.",
    "shopping.batch.nothing": "No products recognised yet. Try separating them with commas.",
    "shopping.batch.add": "Add to list · {n}",
    "shopping.batch.addNone": "Add",
    "shopping.batch.added": "Added to your list: {n}",
  },
  nl: {
    "shopping.share.needsPlus": "Delen met het gezin hoort bij Plus. Als één persoon in het gezin een abonnement heeft (de gratis proefperiode telt ook), deelt het hele gezin de lijst, het huishoudboekje, de voorraad, de spullen en die Plus.",
    "shopping.share.paused": "Delen is gepauzeerd voor dit gezin: iemand in het gezin heeft NutriCart Plus nodig om weer te delen.",
    "shopping.share.title": "Mijn gezin",
    "shopping.share.stripOff": "Delen met je gezin",
    "shopping.share.short": "Delen",
    "shopping.share.stripOffSub": "Boodschappenlijst, huishoudboekje, voorraad en spullen, samen",
    "shopping.share.intro": "Eén boodschappenlijst, huishoudboekje, voorraad en spullenlijst voor het hele gezin: wie een bon scant, eten koopt of iets afvinkt, iedereen ziet het meteen. Eén Plus voor het hele gezin. Ieders maaltijden, gewicht en klantenkaarten blijven privé.",
    "shopping.share.step3": "Gezinsleden met een NutriCart-account tikken op „Vragen om mee te doen”; zodra jij hier op „Toestaan” tikt, delen ze het huishoudboekje, de voorraad en Plus.",
    "shopping.share.safety": "Met alleen de link (zonder account) kan men alleen de boodschappenlijst zien en wijzigen; meedoen met het gezin (huishoudboekje enz.) kan alleen met jouw toestemming.",
    "shopping.share.joinTitle": "Meedoen met dit gezin",
    "shopping.share.joinHint": "Eenmaal binnen deelt het gezin de boodschappenlijst, het huishoudboekje, de voorraad, de spullen en Plus; wat je zelf bijhield wordt samengevoegd. Je maaltijden, gewicht en klantenkaarten blijven van jou. Iemand in het gezin moet je toestaan.",
    "shopping.share.join": "Vragen om mee te doen",
    "shopping.share.signUpHint": "Meld je aan bij NutriCart (de boodschappenlijst is altijd gratis), vraag dan om mee te doen en deel één Plus.",
    "shopping.share.signUp": "Gratis aanmelden en vragen",
    "shopping.share.signIn": "Ik heb een account: inloggen en vragen",
    "shopping.share.stopBody": "De link werkt niet meer en gezinsleden gaan terug naar hun eigen (lege) account. Het gedeelde huishoudboekje, de voorraad en de lijst blijven bij jou.",
    "shopping.share.leaveBody": "Je gaat terug naar je eigen account, met een lege lijst, huishoudboekje en voorraad; de gezinsgegevens blijven bij het gezin. Later kun je opnieuw vragen.",
    "shopping.share.leave": "Dit gezin verlaten",
    "shopping.share.leaveTitle": "Het gezin verlaten?",
    "shopping.share.youJoined": "Je zit in het gezin van {name}: lijst, huishoudboekje, voorraad, spullen en Plus worden gedeeld.",
    "shopping.share.stripOn": "Gezin van {name} · {n} personen",
    "shopping.share.stripOnSub": "Lijst, huishoudboekje en voorraad gedeeld: wijzigingen ziet iedereen meteen",
    "shopping.share.stripAsks": "{n} vragen om mee te doen — tik om te bekijken",
    "shopping.share.asks": "{name} vraagt om mee te doen",
    "shopping.share.asksHint": "Na toestaan ziet die persoon het huishoudboekje, de voorraad en de spullen. Sta alleen gezinsleden toe.",
    "shopping.share.accept": "Toestaan",
    "shopping.share.decline": "Weigeren",
    "shopping.share.waiting": "Je hebt gevraagd om bij het gezin van {name} te komen; wachten op toestemming.",
    "shopping.share.asked": "Verzoek verstuurd. Zodra iemand in het gezin van {name} toestaat, verschijnen de lijst, het huishoudboekje en de voorraad in je app.",
    "shopping.share.step1": "Tik op „Naar gezin sturen” en stuur de link via WhatsApp, WeChat of sms.",
    "shopping.share.step2": "Je gezin opent de link en ziet de lijst; toevoegen en afvinken kan zonder account.",
    "shopping.share.make": "Gezinslink maken",
    "shopping.share.send": "Naar gezin sturen",
    "shopping.share.copy": "Link kopiëren",
    "shopping.share.copied": "Link gekopieerd: plak hem in WhatsApp of WeChat voor je gezin.",
    "shopping.share.message": "Onze boodschappenlijst — open hem om te zien, toe te voegen en af te vinken:",
    "shopping.share.who": "In het gezin ({n})",
    "shopping.share.me": "ik",
    "shopping.share.renew": "Nieuwe link",
    "shopping.share.renewTitle": "Een nieuwe link maken?",
    "shopping.share.renewBody": "De oude link werkt meteen niet meer (bijv. als hij naar de verkeerde persoon ging). Gezinsleden die meedoen blijven op de lijst.",
    "shopping.share.stop": "Stoppen met delen",
    "shopping.share.stopTitle": "Stoppen met delen?",
    "shopping.share.gone": "Deze link werkt niet meer. Vraag je gezin om een nieuwe.",
    "shopping.share.family": "Boodschappenlijst gezin",
    "shopping.share.listOf": "Gezinslijst van {name}",
    "shopping.share.guestIntro": "Zet erop wat je bedenkt; tik op het rondje als je het gekocht hebt. Je gezin ziet het meteen.",
    "shopping.share.addPh": "bijv. 2 melk, brood",
    "shopping.share.add": "Toevoegen",
    "shopping.share.toBuy": "Te kopen · {n}",
    "shopping.share.allDone": "Alles gekocht 👍",
    "shopping.share.bought": "Gekocht · {n}",
    "shopping.share.openMine": "Mijn boodschappenlijst openen",
    "shopping.cheer.say": "Joepie, goed zo!",
    "shopping.cheer.advice": "Gepland én in de aanbieding: de besparing zie je terug bij “aanbiedingen” in je huishoudboekje.",
    "shopping.cheer.line": "Joepie! In de aanbieding gekocht, goed gedaan!",
    "shopping.offer.open": "Fotografeer een aanbieding, deel hem met iedereen",
    "shopping.offer.title": "Deel een aanbieding uit de winkel",
    "shopping.offer.intro": "Een aanbiedingsbord, schapkaartje of folder gezien? Maak een foto, de AI leest de producten en prijzen, en na jouw controle worden ze gedeeld met iedereen op NutriCart. Op ieders boodschappenlijst staat de aanbieding dan bij hetzelfde product. Delen is anoniem: niemand ziet wie de foto maakte.",
    "shopping.offer.needsPlus": "Aanbiedingen delen met een foto hoort bij Plus; aanbiedingen van anderen zien is altijd gratis",
    "shopping.offer.photo": "Aanbiedingsbord of folder",
    "shopping.offer.reading": "Aanbiedingen lezen…",
    "shopping.offer.store": "Welke winkel",
    "shopping.offer.until": "t/m {date}",
    "shopping.offer.was": "was {amount}",
    "shopping.offer.check": "Controleer even: vink alleen aan wat goed gelezen is. Zonder einddatum loopt een aanbieding tot en met zondag, zoals in Nederlandse winkels.",
    "shopping.offer.share": "Deel {n} aanbiedingen",
    "shopping.offer.shared": "{n} aanbiedingen gedeeld, dank je!",
    "shopping.offer.noneRead": "Geen aanbiedingen gevonden op deze foto. Probeer een scherpere foto met de prijs en productnaam in beeld.",
    "shopping.offer.needStore": "Vul in welke winkel.",
    "shopping.offer.needOne": "Vink minstens één aanbieding aan.",
    "shopping.offer.dailyLimit": "Je hebt vandaag {limit} aanbiedingen gedeeld, het maximum per dag. Morgen kan het weer.",
    "shopping.offer.mine": "Mijn gedeelde aanbiedingen die nog lopen ({n})",
    "shopping.offer.remove": "„{name}” intrekken",
    "shopping.offer.lastDeal": "Laatst in de aanbieding gekocht bij {store} op {date}, {amount} bespaard",
    "shopping.autoExtra": "Je bent in de winkel, dus wat je nu toevoegt is als \"niet gepland\" gemarkeerd. Tik op het potlood om het te wijzigen.",
    "shopping.willAdd": "Wordt toegevoegd: {list}",
    "shopping.addHint": "Voeg er meerdere tegelijk toe, gescheiden door komma's, bijv. \"2 pakken melk, brood, 6 eieren\". Tik op de microfoon om het in te spreken.",
    "shopping.addHintShop": "Je bent in de winkel: wat je nu toevoegt telt als niet gepland.",
    "shopping.tapToTick": "Tik op een product om het af te vinken; tik op het potlood om aantal, eenheid of soort te wijzigen.",
    "shopping.recordReceiptPlus": "Fotografeer de kassabon en je lijst wordt er regel voor regel mee vergeleken, statiegeld inbegrepen. Dit is een Plus-functie.",
    "shopping.clearBodyUnlinked": "{n} gekochte producten van de lijst halen (ze blijven een week in je aankoopgeschiedenis). {m} daarvan staan nog niet op een bon en kunnen daarna niet meer gekoppeld worden.",
    "shopping.onReceipt": "Op een bon, tik om te openen",
    "shopping.onReceiptShort": "Op bon",
    "shopping.recordAmount": "Geen bon? Noteer het bedrag",
    "shopping.recordReceiptHint": "Heb je een bon? Gebruik „Bon scannen” op het beginscherm of in het huishoudboekje: bij het opslaan wordt dit afgevinkt, de uitgave geboekt en het eten in de voorraad gezet.",
    "shopping.atHome": "nog {qty} in de voorraad",
    "shopping.atHomeDays": "nog {qty} in de voorraad, nog {n} dagen goed",
    "shopping.atHomeExpired": "nog {qty} in de voorraad, maar over de datum",
    "shopping.atHomeToast": "Even ter info: „{home}” — {more}. Toch „{name}” kopen?",
    "shopping.atHomeSkip": "Niet kopen",
    "shopping.estimate": "Ongeveer {amount} deze keer ({n} van {total} met bekende prijs)",
    "shopping.budgetLeft": "Nog {amount} over in het budget van deze maand",
    "shopping.budgetOver": "{amount} over het budget van deze maand",
    "shopping.estimateOver": "kan over het budget gaan",
    "shopping.soon.title": "Bijna op? Volgens hoe vaak je het koopt",
    "shopping.soon.line": "Meestal elke {every} dagen, laatst op {date}",
    "shopping.soon.add": "Toevoegen",
    "shopping.soon.addAll": "Alles toevoegen",
    "shopping.soon.addOne": "„{name}” op de lijst zetten",
    "shopping.soon.hint": "Berekend uit je bonnen: alleen voor dingen die je 3 keer of vaker kocht, en niet als het al op de lijst staat of de voorraad nog genoeg heeft.",
    "shopping.boughtBefore": "gekocht {date} ({n}× in een halfjaar)",
    "shopping.boughtBeforeToast": "Even ter info: bij je spullen staat „{home}”, gekocht {date} ({n}× in een halfjaar). Heb je „{name}” echt nog eens nodig?",
    "shopping.batch.kindHint": "Woorden als \"aanbieding\" of \"extra\" bepalen de soort automatisch; tik op het label achter een product om het te wijzigen.",
    "shopping.batch.changeKind": "Soort van “{name}” wijzigen",
    "shopping.nudge.1.say": "Oepsie! Dat stond niet op je lijstje. Heb je het echt nodig?",
    "shopping.nudge.2.say": "Hihi, geld groeit niet aan bomen! Zullen we een beetje sparen?",
    "shopping.nudge.3.say": "Elk beetje dat je bespaart telt. Goed bezig!",
    "shopping.nudge.4.say": "Wacht eens even! Is er thuis nog wat van?",
    "shopping.title": "Boodschappenlijst",
    "shopping.hero": "Eerst plannen, dan winkelen",
    "shopping.heroSub": "Schrijf op wat je nodig hebt, vink het af in de winkel en laat het extraatje liggen.",
    "shopping.add": "Op de lijst zetten",
    "shopping.added": "{name} toegevoegd",
    "shopping.alreadyListed": "Dit staat al op je lijst.",
    "shopping.removed": "{name} verwijderd",
    "shopping.open": "Nog halen · {n}",
    "shopping.completed": "In het mandje · {n}",
    "shopping.allDone": "Je hebt alles!",
    "shopping.markBought": "{name} afvinken",
    "shopping.markOpen": "{name} weer open zetten",
    "shopping.editItem": "{name} bewerken",
    "shopping.stillNeed": "nog {qty} nodig",
    "shopping.overPlan": "{qty} meer dan gepland",
    "shopping.clearCompleted": "Afgevinkte wissen",
    "shopping.clearBody": "Alles wat je al hebt gekocht ({n}) van de lijst halen. Het blijft een week in je aankoopgeschiedenis.",
    "shopping.clearConfirm": "Wissen",
    "shopping.cleared": "Afgevinkte producten gewist",
    "shopping.retention": "Gekochte producten gaan na {n} dagen van de lijst en blijven {h} dagen in je aankoopgeschiedenis. Wat je nog moet halen, blijft staan tot je het verwijdert.",
    "shopping.history.open": "Aankoopgeschiedenis (laatste {n} dagen)",
    "shopping.history.title": "Aankoopgeschiedenis",
    "shopping.history.intro": "Wat je de laatste {n} dagen hebt gekocht, per dag. Ouder wordt vanzelf verwijderd.",
    "shopping.history.empty": "De laatste {n} dagen niets gekocht.",
    "shopping.history.booked": "In het budget: {store} {amount}",
    "shopping.history.notBooked": "Nog niet in het budget",
    "shopping.history.count": "{n} producten",
    "shopping.empty.title": "Je lijst is nog leeg",
    "shopping.empty.body": "Typ hierboven een product en tik op ‘Op de lijst zetten’, kies uit veelgekochte producten, of gebruik ‘Meerdere typen of inspreken’ om er een paar tegelijk toe te voegen.",

    "shopping.field.name": "Product",
    "shopping.field.namePlaceholder": "bijv. Melk",
    "shopping.field.needed": "Aantal",
    "shopping.field.bought": "Gekocht",
    "shopping.field.unit": "Eenheid",
    "shopping.field.unitPlaceholder": "flessen, pakken, kg…",
    "shopping.field.category": "Categorie",
    "shopping.field.kind": "Gepland of niet",
    "shopping.kind.planned": "Gepland",
    "shopping.kind.extra": "Ongepland",
    "shopping.kind.discount": "In de aanbieding",
    "shopping.error.check": "Controleer de productnaam en het aantal.",
    "shopping.error.qty": "Vul een getal in van 0,01 tot 10000",

    "shopping.cat.other": "Overig",
    "shopping.cat.produce": "Groente & fruit",
    "shopping.cat.protein": "Vlees, eieren & zuivel",
    "shopping.cat.staples": "Voorraadkast",
    "shopping.cat.snacks": "Snacks & drinken",
    "shopping.cat.household": "Huishouden",

    "shopping.edit.title": "Product bewerken",
    "shopping.edit.remove": "Verwijderen",

    "shopping.picker.title": "Kies uit veelgekochte producten",
    "shopping.picker.recent": "Recent",
    "shopping.picker.listed": "Staat al op de lijst",
    "shopping.picker.addOne": "{name} op de lijst zetten",

    "shopping.nudge.1": "Heb je het echt nodig?",
    "shopping.nudge.2": "Geld groeit niet aan bomen!",
    "shopping.nudge.3": "Laten we besparen waar het kan!",
    "shopping.nudge.4": "Misschien heb je thuis nog wat?",
    "shopping.nudge.advice": "Sta even stil bij wat je al in huis hebt en bij je budget.",

    "shopping.batch.open": "Inspreken",
    "shopping.batch.title": "Meerdere producten toevoegen",
    "shopping.batch.intro": "Schrijf alles wat je nodig hebt in één keer op, gescheiden door komma's of nieuwe regels.",
    "shopping.batch.introVoice": "Schrijf of zeg alles wat je nodig hebt in één keer, gescheiden door komma's of nieuwe regels. De spraakherkenning zit in je browser: gratis, zonder AI-tegoed.",
    "shopping.batch.label": "Wat heb je nodig?",
    "shopping.batch.placeholder": "2 pakken melk en brood",
    "shopping.batch.example": "Je kunt aantallen en eenheden noemen, zoals ‘2 pakken melk’ of ‘eieren 6’.",
    "shopping.batch.speak": "Begin met praten",
    "shopping.batch.stop": "Stoppen",
    "shopping.batch.listening": "Aan het luisteren…",
    "shopping.batch.micNote": "Tik op ‘Begin met praten’; het stopt vanzelf als je even pauzeert. Je browser vraagt misschien om de microfoon te gebruiken.",
    "shopping.batch.micBlocked": "De microfoon is geblokkeerd. Sta hem toe in je browserinstellingen, of typ het gewoon.",
    "shopping.batch.noSpeech": "We hoorden niets. Probeer het nog eens.",
    "shopping.batch.noMic": "Geen microfoon gevonden. Je kunt het ook typen.",
    "shopping.batch.micNetwork": "Spraakherkenning heeft een verbinding nodig. Probeer het later nog eens of typ het.",
    "shopping.batch.micFailed": "Spraakherkenning kon niet starten. Typ het liever.",
    "shopping.batch.preview": "Gevonden · {n}",
    "shopping.batch.untick": "Vink uit wat je niet wilt. Je kunt later op elk product tikken om het aan te passen.",
    "shopping.batch.nothing": "Nog geen producten herkend. Probeer ze met komma's te scheiden.",
    "shopping.batch.add": "Op de lijst zetten · {n}",
    "shopping.batch.addNone": "Toevoegen",
    "shopping.batch.added": "Toegevoegd aan je lijst: {n}",
  },
} satisfies Dict;
